__turbopack_context__.v({
  "className": "LMfYCa_className",
  "variable": "LMfYCa_variable",
});
